import { AssertException } from '../assert.exception';

export class AssertIsNotEmptyArrayException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsNotEmptyArrayException.prototype);
  }
}
